import {
  type Entity,
  type QueriesObject,
  type QueryResults,
  type System,
} from '../../odie';

import { BlockComponent } from '../components/BlockComponent';
import { PhaseComponent } from '../components/PhaseComponent';
import { AlarmBlockComponent } from '../components/AlarmBlockComponent';
import { AlarmBlockEntity } from '../entities/BlockEntity';
import type { GameScene } from '../GameScene';

/*
    handles alarm block specifics
*/
export class AlarmBlockSystem implements System {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockAlarm';
  public static Queries: QueriesObject = {
    block: {
      components: [BlockComponent, AlarmBlockComponent],
    },
    phase: {
      components: [PhaseComponent],
      modified: true,
    },
  };

  // fields
  //-------------------------------------------------------------------------
  // injected
  public scene!: GameScene;
  public queries!: QueryResults;
  private _lastMoveCount?: number;

  // impl
  //-------------------------------------------------------------------------
  public modifiedQuery(
    entity: Entity,
    component: PhaseComponent,
    properties: { phase: string },
  ) {
    // if move input phase step alarms
    if (properties.phase && component.phase === 'input' && component.moved) {
      // Alarm should be restored only if the move count has changed
      // Boosters (hammer, airplane) do not count as moves
      const moveCount = component.moves;
      const moveCountChanged = this._lastMoveCount !== moveCount;
      this._lastMoveCount = moveCount;
      this._stepAlarm(moveCountChanged);
    }
  }

  // private: actions
  //-------------------------------------------------------------------------
  private _stepAlarm(moveCountChanged: boolean) {
    // restore alarms
    this.queries.block.forEach((entity: AlarmBlockEntity) => {
      const alarm = entity.c.blockAlarm;

      // If alarm idle and move count has changed, restore count
      if (alarm.idle && moveCountChanged) {
        alarm.count = 1;
      }

      // reset idle state
      alarm.idle = true;
    });
  }
}
